export default {
    dataModel: {
      types: ['cdlt:JobOpportunities'],
      fieldsMapping: {
        title: 'pair:label'
      }
    },
  };
  